export function ExperiencePage() {
  return (
    <div className="site-container page">
      <section className="page-intro">
        <p className="page-intro__label">Experience</p>
        <h1>Work that connects people, institutions, and practical systems.</h1>
        <p>This page will hold the narrative version of leadership, professional work, technical projects, and academic background. The résumé remains available as a focused reference document.</p>
      </section>
    </div>
  );
}
